const generate = require('nanoid/generate');

let generateId = () => {
  let id = generate('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890', 25);
  return id;
}

export default generateId;